/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Shortcuts_Commandmenu1Inputs */

const he_help_shortcuts_commandmenu1 = /** @type {(inputs: Help_Shortcuts_Commandmenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פתיחת תפריט פקודות`)
};

const en_help_shortcuts_commandmenu1 = /** @type {(inputs: Help_Shortcuts_Commandmenu1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open command menu`)
};

/**
* | output |
* | --- |
* | "Open command menu" |
*
* @param {Help_Shortcuts_Commandmenu1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const help_shortcuts_commandmenu1 = /** @type {((inputs?: Help_Shortcuts_Commandmenu1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Shortcuts_Commandmenu1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_shortcuts_commandmenu1(inputs)
	return en_help_shortcuts_commandmenu1(inputs)
});
export { help_shortcuts_commandmenu1 as "help_shortcuts_commandMenu" }